import "./Video.css"


export default function Video(){
    return (
        <div className="video-outer-container">
            
            <div className="video-wrapper">
                <div className="video-box">
                    <div className="inner-video-container"> 
                        <iframe
                            src={`https://www.youtube.com/embed/aircAruvnKk`}
                            title="YouTube video"
                            allowFullScreen
                            className="iframe-video"
                        />
                    </div>
                    
                </div>
            </div>

        </div>
    )
}